export type IWixApi = ReturnType<typeof wixApi>;

/* @ngInject */
export function wixApi(wixSdk, $timeout, $q) {
  return {
    getCompInstID,
    getSiteURL,
    getViewMode,
    getCompID,
    getMobileMode,
  };

  function getCompInstID() {
    return wixSdk.Utils.getInstanceId();
  }

  function getCompID() {
    const compId = wixSdk.Utils.getCompId();
    return compId;
  }

  function getSiteURL() {
    const defer = $q.defer();
    $timeout(function () {
      wixSdk.getSiteInfo(function (siteInfo) {
        const siteURL = siteInfo.baseUrl;
        defer.resolve(siteURL);
      });
    }, 0);
    return defer.promise;
  }

  function getViewMode() {
    return wixSdk.Utils.getViewMode();
  }

  function getMobileMode() {
    const deviceType = wixSdk.Utils.getDeviceType();
    return deviceType === 'mobile';
  }
}
